// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__mtCDd","body":"styles_body__Fv2dL","message":"styles_message__kjxgt","footer":"styles_footer__WOIYv"};